import { input, output } from '@angular/core';
import { RedtailIntegrationService } from 'IntegrationsApp/ts/services/redtail-integration-service';
import * as i0 from "@angular/core";
import * as i1 from "IntegrationsApp/ts/services/redtail-integration-service";
import * as i2 from "@angular/common";
import * as i3 from "Angular/features/directives/image/image.directive";
import * as i4 from "../../../../../../../ycharts/static/ts/features/components/loaders/loading-symbol/loading-symbol.component";
import * as i5 from "../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/modal-base.component";
import * as i6 from "../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/simple-modal-footer.component";
import * as i7 from "../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/simple-modal-header.component";
function RedtailCredentialsModalComponent_ycn_loading_symbol_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ycn-loading-symbol", 8);
} if (rf & 2) {
    i0.ɵɵproperty("loaderMessage", "Logging in to Redtail...");
} }
function RedtailCredentialsModalComponent_div_4_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 20);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("textContent", ctx_r1.errorMessage);
} }
function RedtailCredentialsModalComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 9)(1, "div", 10)(2, "div", 11);
    i0.ɵɵelement(3, "img", 12);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 13)(5, "form", 14);
    i0.ɵɵtemplate(6, RedtailCredentialsModalComponent_div_4_div_6_Template, 1, 1, "div", 15);
    i0.ɵɵelementStart(7, "div", 16)(8, "div", 17);
    i0.ɵɵtext(9, "Redtail Username:");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "input", 18, 0);
    i0.ɵɵlistener("blur", function RedtailCredentialsModalComponent_div_4_Template_input_blur_10_listener() { i0.ɵɵrestoreView(_r1); const usernameInput_r3 = i0.ɵɵreference(11); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.setUsername(usernameInput_r3.value)); })("keydown.enter", function RedtailCredentialsModalComponent_div_4_Template_input_keydown_enter_10_listener() { i0.ɵɵrestoreView(_r1); const passwordInput_r4 = i0.ɵɵreference(16); return i0.ɵɵresetView(passwordInput_r4.blur()); });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(12, "div", 16)(13, "div", 17);
    i0.ɵɵtext(14, "Redtail Password:");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(15, "input", 19, 1);
    i0.ɵɵlistener("blur", function RedtailCredentialsModalComponent_div_4_Template_input_blur_15_listener() { i0.ɵɵrestoreView(_r1); const passwordInput_r4 = i0.ɵɵreference(16); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.setIntegrationPassword(passwordInput_r4.value)); })("keydown.enter", function RedtailCredentialsModalComponent_div_4_Template_input_keydown_enter_15_listener() { i0.ɵɵrestoreView(_r1); const passwordInput_r4 = i0.ɵɵreference(16); return i0.ɵɵresetView(passwordInput_r4.blur()); });
    i0.ɵɵelementEnd()()()()()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("imageSrc", "integrations/images/redtail-logo.png");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r1.errorMessage !== "");
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("placeholder", "Enter Redtail username");
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("placeholder", "Enter Redtail password");
} }
/**
 * Shared Redtail username/password credentials modal.
 *
 * Owns the login form, the `activateRedtailIntegration` call, and the status-code -> message error
 * mapping. Contract:
 *  - `success`   emitted once on a 200 (credentials accepted, user_key stored). The modal closes.
 *  - `cancelled` emitted only when the user dismisses the modal (cancel / header close / backdrop)
 *                WITHOUT a successful login.
 *  - On error the modal stays open showing the message and emits NEITHER, so the caller's state is
 *    left untouched for a retry. (CAMP relies on this: emitting `cancelled` here would clear its
 *    optimistic active-partner and strand the toggle after a successful retry.)
 */
export class RedtailCredentialsModalComponent {
    constructor(redtailIntegrationService) {
        this.redtailIntegrationService = redtailIntegrationService;
        this.header = input('Activate Redtail Integration', ...(ngDevMode ? [{ debugName: "header" }] : []));
        this.success = output();
        this.cancelled = output();
        this.modalOpen = false;
        this.username = '';
        this.integrationPassword = '';
        this.errorMessage = '';
        this.loading = false;
    }
    openModal() {
        this.modalOpen = true;
    }
    closeModal() {
        this.reset();
        this.cancelled.emit();
    }
    reset() {
        this.modalOpen = false;
        this.errorMessage = '';
        this.username = '';
        this.integrationPassword = '';
        this.loading = false;
    }
    setUsername(username) {
        this.username = username;
    }
    setIntegrationPassword(integrationPassword) {
        this.integrationPassword = integrationPassword;
    }
    activateHandler() {
        if (this.username !== '' && this.integrationPassword !== '') {
            this.loading = true;
            this.redtailIntegrationService
                .activateRedtailIntegration(this.username, this.integrationPassword)
                .subscribe({
                next: (res) => {
                    if (res.status === 200) {
                        this.reset();
                        this.success.emit();
                    }
                },
                error: (error) => {
                    if (error.status === 403) {
                        this.errorMessage =
                            'Something went wrong, check that your username and password are correct';
                    }
                    else if (error.status === 424) {
                        this.errorMessage = 'Service unavailable, please try again later';
                    }
                    else if (error.status === 401) {
                        this.errorMessage = 'Invalid Request.';
                    }
                    this.loading = false;
                },
                complete: () => {
                    this.loading = false;
                },
            });
        }
    }
}
RedtailCredentialsModalComponent.ɵfac = function RedtailCredentialsModalComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || RedtailCredentialsModalComponent)(i0.ɵɵdirectiveInject(i1.RedtailIntegrationService)); };
RedtailCredentialsModalComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: RedtailCredentialsModalComponent, selectors: [["ycn-redtail-credentials-modal"]], inputs: { header: [1, "header"] }, outputs: { success: "success", cancelled: "cancelled" }, standalone: false, decls: 6, vars: 7, consts: [["usernameInput", ""], ["passwordInput", ""], [3, "closeModalHandler", "extraModalClasses", "open"], [3, "closeModalHandler", "header"], [1, "modal-body"], [3, "loaderMessage", 4, "ngIf"], ["class", "modal-section", 4, "ngIf"], [3, "cancelHandler", "submitHandler", "submitButtonText", "disableSubmission"], [3, "loaderMessage"], [1, "modal-section"], [1, "row"], [1, "col-4", "d-flex", "align-items-center", "justify-content-center"], ["ycnImage", "", 3, "imageSrc"], [1, "col"], ["action", "javascript:void(0);"], ["class", "form-row text-red", 3, "textContent", 4, "ngIf"], [1, "form-row"], [1, "form-label", "form-label-thin"], ["type", "text", "autocomplete", "username", 1, "form-control", 3, "blur", "keydown.enter", "placeholder"], ["type", "password", "autocomplete", "current-password", 1, "form-control", 3, "blur", "keydown.enter", "placeholder"], [1, "form-row", "text-red", 3, "textContent"]], template: function RedtailCredentialsModalComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "ycn-modal-base", 2);
        i0.ɵɵlistener("closeModalHandler", function RedtailCredentialsModalComponent_Template_ycn_modal_base_closeModalHandler_0_listener() { return ctx.closeModal(); });
        i0.ɵɵelementStart(1, "ycn-simple-modal-header", 3);
        i0.ɵɵlistener("closeModalHandler", function RedtailCredentialsModalComponent_Template_ycn_simple_modal_header_closeModalHandler_1_listener() { return ctx.closeModal(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(2, "div", 4);
        i0.ɵɵtemplate(3, RedtailCredentialsModalComponent_ycn_loading_symbol_3_Template, 1, 1, "ycn-loading-symbol", 5)(4, RedtailCredentialsModalComponent_div_4_Template, 17, 4, "div", 6);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(5, "ycn-simple-modal-footer", 7);
        i0.ɵɵlistener("cancelHandler", function RedtailCredentialsModalComponent_Template_ycn_simple_modal_footer_cancelHandler_5_listener() { return ctx.closeModal(); })("submitHandler", function RedtailCredentialsModalComponent_Template_ycn_simple_modal_footer_submitHandler_5_listener() { return ctx.activateHandler(); });
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵproperty("extraModalClasses", "modal-dialog")("open", ctx.modalOpen);
        i0.ɵɵadvance();
        i0.ɵɵproperty("header", ctx.header());
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.loading);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", !ctx.loading);
        i0.ɵɵadvance();
        i0.ɵɵproperty("submitButtonText", "Log in to Redtail")("disableSubmission", ctx.loading || ctx.username === "" || ctx.integrationPassword === "");
    } }, dependencies: [i2.NgIf, i3.ImageDirective, i4.LoadingSymbolComponent, i5.ModalBaseComponent, i6.SimpleModalFooterComponent, i7.SimpleModalHeaderComponent], encapsulation: 2 });
